import 'globals';
import webkitLineClamp from 'webkit-line-clamp';
import PageLoadedQueue from "./PageLoadedQueue";

/**
 * Clamp lines of text
 */
export function clampLines() {
    const elements: NodeListOf<HTMLElement> = document.querySelectorAll('.croppedLines');

    if (elements.length) {
        elements.forEach((element) => {
            const lines = element.dataset.linecrop;

            if (!lines) {
                return;
            }

            webkitLineClamp(element, parseInt(lines));
        });
    }
}

PageLoadedQueue.addFunction(clampLines);

declare global {
    interface Window {
        clampLines: Function;
    }
}
